// Single seam between the app and whatever error-tracking service we end up
// wiring in (Sentry or similar). Until then, reports just go to the console.
//
// To hook up a real provider later: call `Sentry.init(...)` (or equivalent)
// once at app startup, then `setErrorReporter((error, context) =>
// Sentry.captureException(error, { extra: context }))` — nothing else in the
// app (ErrorBoundary included) needs to change.

export interface ErrorReportContext {
  componentStack?: string | null;
  [key: string]: unknown;
}

export type ErrorReporter = (error: Error, context?: ErrorReportContext) => void;

let reporter: ErrorReporter = (error, context) => {
  console.error("[errorReporting]", error, context);
};

export const setErrorReporter = (next: ErrorReporter): void => {
  reporter = next;
};

export const reportError = (error: Error, context?: ErrorReportContext): void => {
  reporter(error, context);
};
